import qs from 'qs';

import { SearchState } from '~/utils/types';

/**
 * Converts a given path into an object we can use to populate our search state
 * For example: /page?query=foo -> { query: 'foo' }
 * and: /page => { }
 */
export const pathToSearchState = (path: string): SearchState => {
  const parsed = path.includes('?')
    ? qs.parse(path.substring(path.indexOf('?') + 1))
    : {};
  return {
    query: (parsed.query as string) || null,
  };
};

/**
 * Converts a given search state into a new path we can use with router.replace()
 * For example: { query: 'foo' } => /page?query=foo
 * and: { } => /page
 */
export const searchStateToPath = (
  currentPath: string,
  searchState: SearchState,
) => {
  const basePath = currentPath.includes('?')
    ? currentPath.split('?')[0]
    : currentPath;

  if (!searchState.query) {
    return basePath;
  }

  return `${basePath}?query=${searchState.query}`;
};
